import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const useIsMobile = () => {
  const [m, setM] = useState(window.innerWidth < 640);
  useEffect(() => {
    const h = () => setM(window.innerWidth < 640);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return m;
};

const PLANES = [
  {
    id: 'control',
    nombre: 'CONTROL',
    precio: '14€',
    periodo: '/mes',
    desc: 'hasta 20 empleados · sin IVA',
    features: ['Fichaje web y móvil', 'Control horario legal', 'Vacaciones y ausencias', 'Informes y exportación'],
  },
  {
    id: 'gestion',
    nombre: 'GESTIÓN',
    precio: '29€',
    periodo: '/mes',
    desc: 'hasta 50 empleados · sin IVA',
    destacado: true,
    features: ['Todo lo de Control', 'Proyectos y tareas', 'Imputación de horas', 'Rentabilidad por proyecto'],
  },
  {
    id: 'empresa',
    nombre: 'EMPRESA',
    precio: '69€',
    periodo: '/mes',
    desc: 'hasta 100 empleados · sin IVA',
    features: ['Todo lo de Gestión', 'Múltiples admins', 'API y exportaciones', 'Soporte prioritario'],
  },
];

export default function Registro() {
  const isMobile = useIsMobile();
  const [plan, setPlan] = useState('gestion');
  const [form, setForm] = useState({ nombre: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres'); return; }
    setCargando(true);
    setError('');
    try {
      const res = await API.post('/auth/registro', { ...form, plan });
      login(res.data.access_token, res.data.usuario);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al registrarse');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',background:'#16181d',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'32px 20px'}}>

      <div style={{marginBottom:'32px',textAlign:'center'}}>
        <div style={{fontFamily:'sans-serif',fontSize:'26px',fontWeight:'700',color:'#eef0f6',letterSpacing:'1px'}}>
          TEMPO<span style={{color:'#4f8ef7'}}>.</span>GESTIÓN
        </div>
        <p style={{color:'#7a8099',fontSize:'14px',marginTop:'8px'}}>7 días gratis · Sin tarjeta · Cancela cuando quieras</p>
      </div>

      {/* Selector de plan */}
      <div style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',gap:'8px',width:'100%',maxWidth:'720px',marginBottom:'24px'}}>
        {PLANES.map(p => (
          <div key={p.id} onClick={() => setPlan(p.id)} style={{
            background: plan === p.id ? (p.destacado ? '#4f8ef7' : '#1e2128') : '#1e2128',
            border: plan === p.id ? '2px solid #4f8ef7' : '1px solid #2e3140',
            borderRadius:'6px', padding:'20px 16px', cursor:'pointer', position:'relative',
            transition:'all 0.15s',
            outline: p.destacado && plan === p.id ? 'none' : 'none',
          }}>
            {p.destacado && (
              <div style={{position:'absolute',top:'-10px',left:'50%',transform:'translateX(-50%)',background:'#e8a838',color:'#000',fontSize:'9px',fontWeight:'700',padding:'2px 8px',borderRadius:'2px',whiteSpace:'nowrap',fontFamily:'monospace'}}>MÁS POPULAR</div>
            )}
            <div style={{fontFamily:'monospace',fontSize:'10px',letterSpacing:'2px',color: plan===p.id && p.destacado ? 'rgba(255,255,255,0.8)' : '#7a8099',marginBottom:'8px'}}>{p.nombre}</div>
            <div style={{display:'flex',alignItems:'baseline',gap:'2px',marginBottom:'4px'}}>
              <span style={{fontSize:'28px',fontWeight:'700',color: plan===p.id && p.destacado ? '#fff' : '#eef0f6'}}>{p.precio}</span>
              <span style={{fontSize:'13px',color: plan===p.id && p.destacado ? 'rgba(255,255,255,0.7)' : '#7a8099'}}>{p.periodo}</span>
            </div>
            <div style={{fontSize:'11px',color: plan===p.id && p.destacado ? 'rgba(255,255,255,0.7)' : '#7a8099',marginBottom:'12px'}}>{p.desc}</div>
            <ul style={{listStyle:'none',padding:0,margin:0}}>
              {p.features.map(f => (
                <li key={f} style={{fontSize:'12px',color: plan===p.id && p.destacado ? 'rgba(255,255,255,0.9)' : '#aab',padding:'3px 0',display:'flex',gap:'6px',alignItems:'flex-start'}}>
                  <span style={{color: plan===p.id && p.destacado ? '#fff' : '#4f8ef7',flexShrink:0}}>✓</span>{f}
                </li>
              ))}
            </ul>
            {plan === p.id && (
              <div style={{marginTop:'12px',background:'rgba(255,255,255,0.15)',borderRadius:'2px',padding:'4px 8px',fontSize:'11px',color:'#fff',textAlign:'center',fontFamily:'monospace'}}>✓ SELECCIONADO</div>
            )}
          </div>
        ))}
      </div>

      {/* Formulario */}
      <div style={{background:'#1e2128',border:'1px solid #2e3140',borderRadius:'6px',padding:'32px',width:'100%',maxWidth:'720px'}}>
        <h2 style={{color:'#eef0f6',fontSize:'18px',fontWeight:'600',margin:'0 0 24px 0'}}>
          Crear cuenta — Plan {PLANES.find(p=>p.id===plan)?.nombre}
        </h2>

        {error && (
          <div style={{background:'rgba(248,113,113,0.08)',border:'1px solid rgba(248,113,113,0.3)',color:'#f87171',padding:'10px 14px',borderRadius:'4px',fontSize:'13px',marginBottom:'20px'}}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:'16px'}}>
          <div style={{gridColumn: isMobile ? '1 / -1' : '1'}}>
            <label style={{display:'block',fontSize:'12px',color:'#7a8099',marginBottom:'6px',fontFamily:'monospace',letterSpacing:'1px'}}>EMPRESA</label>
            <input style={inputStyle} name="nombre" value={form.nombre} onChange={handleChange} placeholder="Construcciones Pérez SL" required />
          </div>
          <div style={{gridColumn: isMobile ? '1 / -1' : '2'}}>
            <label style={{display:'block',fontSize:'12px',color:'#7a8099',marginBottom:'6px',fontFamily:'monospace',letterSpacing:'1px'}}>EMAIL</label>
            <input style={inputStyle} type="email" name="email" value={form.email} onChange={handleChange} placeholder="tu@empresa.com" required />
          </div>
          <div style={{gridColumn:'1 / -1'}}>
            <label style={{display:'block',fontSize:'12px',color:'#7a8099',marginBottom:'6px',fontFamily:'monospace',letterSpacing:'1px'}}>CONTRASEÑA</label>
            <input style={inputStyle} type="password" name="password" value={form.password} onChange={handleChange} placeholder="Mínimo 8 caracteres" required />
          </div>
          <div style={{gridColumn:'1 / -1'}}>
            <button type="submit" disabled={cargando} style={{
              width:'100%',padding:'14px',background: cargando ? '#2e3140' : '#4f8ef7',
              color: cargando ? '#7a8099' : '#fff',border:'none',borderRadius:'4px',
              fontSize:'15px',fontWeight:'600',cursor: cargando ? 'not-allowed' : 'pointer'
            }}>
              {cargando ? 'Creando cuenta...' : 'Empezar 7 días gratis →'}
            </button>
          </div>
        </form>

        <p style={{fontSize:'12px',color:'#7a8099',textAlign:'center',marginTop:'16px',marginBottom:0}}>
          ¿Ya tienes cuenta? <Link to="/login" style={{color:'#4f8ef7',textDecoration:'none'}}>Inicia sesión</Link>
          <span style={{margin:'0 8px'}}>·</span>
          Sin tarjeta de crédito · Cancela cuando quieras
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  width:'100%', padding:'10px 12px', background:'#252830', border:'1px solid #2e3140',
  color:'#eef0f6', fontSize:'14px', borderRadius:'4px', outline:'none', boxSizing:'border-box'
};
